import { render, staticRenderFns } from "./foodItem.vue?vue&type=template&id=71ec87a8&scoped=true&"
import script from "./foodItem.vue?vue&type=script&lang=js&"
export * from "./foodItem.vue?vue&type=script&lang=js&"
import style0 from "./foodItem.vue?vue&type=style&index=0&id=71ec87a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec87a8",
  null
  
)

export default component.exports